module.exports = __webpack_public_path__ + "static/media/backup2.d175a29d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flat/backup2.svg
// module id = 293
// module chunks = 0